import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Home, Requerimento } from '../../../core/models/requerimento';

@Component({
  selector: 'app-home-requerimento',
  styleUrl: './home-requerimento.scss',
  templateUrl: './home-requerimento.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeRequerimento {
  private readonly router = inject(Router);

  /**
   * Resposta do GET /v1/requerimentos/home, buscada pelo homeRequerimentoResolver antes de a tela abrir: participante,
   * elegibilidade, institutos e requerimento aberto.
   */
  readonly home: Home | null = inject(ActivatedRoute).snapshot.data['home'] ?? null;

  onSubmit() {
    // Já há requerimento aberto (a home o devolveu): retoma sem abrir outro.
    const emAndamento = this.home?.requerimentoEmAndamento;
    if (emAndamento) {
      this.router.navigate([this.rotaDaEtapa(emAndamento)]);
      return;
    }

    // Sem requerimento em andamento: o rascunho é aberto (POST) nos dados cadastrais, ao continuar.
    this.router.navigate(['/requerimento-beneficio/dados-cadastrais']);
  }

  private rotaDaEtapa(requerimento: Requerimento): string {
    // Já enviado (em análise ou pendente de documentação): a jornada termina nos detalhes da solicitação.
    if (requerimento.status !== 'R') return '/requerimento-beneficio/detalhes';

    switch (requerimento.etapaAtual) {
      case 1:
        return '/requerimento-beneficio/dados-cadastrais';
      case 2:
        return '/requerimento-beneficio/configuracao-beneficio';
      default:
        return '/requerimento-beneficio/modalidade-imposto';
    }
  }
}
